import { call, put, takeLatest, select } from 'redux-saga/effects';
import * as apis from '@/apis/serroadshow';
import * as actions from '@/actions';
import { CHECK_STOCK_AVAILABILITY_REQUEST, GET_SER_DEVICE_LIST_REQUEST } from '@/actions/serroadshow/actionTypes';
import { ICheckStockAvailability, IGetSERDeviceListPayload } from '@/actions/serroadshow/models/types';
import { checkCurrentDateBetweenRange } from '@/helpers/common';

export const getAuth = (state) => state.auth;

function* getDeviceListForSerFlow() {
  try {
    const auth = yield select(getAuth);
    const brn = auth.currentAccount?.brn || '';
    const emailId = auth.userInfo?.email || '';
    const payload: IGetSERDeviceListPayload = {
      brn: brn,
      serId: emailId
    };
    const result = yield call(apis.getDeviceListForSerFlow, payload);
    if (result.data?.t1) {
      const validSerList = result.data.t1.filter((ele) => checkCurrentDateBetweenRange(ele.startDate, ele.endDate))
      const equipmentList = validSerList.map((ele) => ele.equipmentList).flat()
      const svcNoList = validSerList.map((ele) => ele.svcNoList).flat()
      const svcNoFilter = svcNoList.filter((value, index, self) => (self.findIndex((ele) => ele.serviceNumber === value.serviceNumber) === index))
      const svcNoFilterList = svcNoFilter.filter((svcno) => svcno.status !== 'R')
      const addressDetail = validSerList.reduce((previousValue, currentValue) => {
        if (Object.keys(currentValue.deliveryDetail).length > 0) {
          return [...previousValue, currentValue.deliveryDetail];
        }
        return [...previousValue]
      }, []);
      yield put(actions.getDeviceListForSerFlow.success({ equipmentList, simList: svcNoFilterList, addressDetail }));
    }
  } catch (error) {
    yield put(actions.getDeviceListForSerFlow.failure(error));
  }
}

function* checkStockAvailability({ payload, callback }: ICheckStockAvailability) {
  try {
    const result = yield call(apis.checkStockAvailability, payload);
    yield put(actions.checkStockAvailability.success(result.data));
    callback(result.data);
  } catch (error) {
    yield put(actions.checkStockAvailability.failure(error));
  }
}

export default function* serRoadshowSagas() {
  yield takeLatest(GET_SER_DEVICE_LIST_REQUEST, getDeviceListForSerFlow);
  yield takeLatest(CHECK_STOCK_AVAILABILITY_REQUEST, checkStockAvailability);
}
